export default __webpack_public_path__ + "static/CynosurePartners_Logo_White-47de76b36a214b9f1bab88fcf4767918.png";